module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/Instagram-color-e68a5c77ccb2a1f08020223c31960220.svg";